import type { RouteRecordRaw } from 'vue-router';
import { WHOLESALE_ROUTE_NAME } from '@/libs/route-name';

export const wholesaleRoute = (): RouteRecordRaw => ({
  path: '/manage/wholesale',
  name: WHOLESALE_ROUTE_NAME.WHOLESALE_LIST,
  component: () => import('@/pages/manage/wholesale/index.vue'),
});

export const wholesaleAddRoute = (): RouteRecordRaw => ({
  path: '/manage/wholesale/add',
  name: WHOLESALE_ROUTE_NAME.ADD_WHOLESALE,
  component: () => import('@/pages/manage/wholesale/add.vue'),
});

export const wholesaleEditRoute = (): RouteRecordRaw => ({
  path: '/manage/wholesale/edit/:id',
  name: WHOLESALE_ROUTE_NAME.EDIT_WHOLESALE,
  component: () => import('@/pages/manage/wholesale/edit.vue'),
});

export const wholesaleDetailRoute = (): RouteRecordRaw => ({
  path: '/manage/wholesale/detail/:id',
  name: WHOLESALE_ROUTE_NAME.WHOLESALE_DETAIL,
  component: () => import('@/pages/manage/wholesale/detail.vue'),
});
